import { immutableEmptyArray } from '../../../lib'
import type { Entity } from '../../entity/index'
import type { HasPlayerId } from '../../player/has_player_id'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'

type MergableOccupantValueOrNull = Entity & HasPlayerId | null

// an mergable is a unit of the same player_id
// and etype_id as the current unit unit
// TODO allow a same-team merge
// which is essentially like donating
// a damaged unit's remaining HP
export default function createMergableValueGrid(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to move
  unit: Entity
): Array<MergableOccupantValueOrNull> {
  const unitPlayerId = (unit as HasPlayerId).player_id
  if (!unitPlayerId) {
    return immutableEmptyArray as unknown as Array<MergableOccupantValueOrNull>
  }
  const data : Array<MergableOccupantValueOrNull> = new Array(gridWidth * gridHeight)
  for (let x = 0; x < gridWidth; x++) {
    for (let y = 0; y < gridHeight; y++) {
      const index = x + (y * gridWidth)
      const positionStack = grid[index]
      if (positionStack) {
        for (let index = 0; index < positionStack.length; index++) {
          const ent = positionStack[index]
          if (ent.etype_id === unit.etype_id) {
            if ((ent as HasPlayerId).player_id === unitPlayerId) {
              data[index] = ent as Entity & HasPlayerId
            }
          }
        }
      }
    }
  }
  return data
}
